import { Close } from '@mui/icons-material';
import { Button, Grid, IconButton } from '@mui/material';
import { useSnackbar } from 'notistack';
import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Collapse } from '@work4all/components/lib/components/collapse';

import { SdObjType } from '@work4all/models/lib/Enums/SdObjType.enum';

import { useMaskContext } from '../../../../../../../hooks/mask-context';
import { FullAddressPicker } from '../../../../../../erp/components/full-address-picker/FullAddressPicker';

export const Assignment: React.FC = () => {
  const { t } = useTranslation();

  const { watch, setValue } = useFormContext();

  const businessPartner = watch('mainAddress.businessPartner');
  const deliveryAddress = watch('deliveryAddress.businessPartner');
  const endCustomer = watch('endCustomer.businessPartner');

  const contact = watch('mainAddress.contact');
  const deliveryAddressContact = watch('deliveryAddress.contact');
  const endCustomerContact = watch('endCustomer.contact');

  const project = watch('project');

  const [editMode, setEditMode] = useState(false);

  const mask = useMaskContext();

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  return (
    <Collapse title={t('MASK.ASSIGNMENT')} defaultOpen={true}>
      <Grid container spacing="1rem">
        <Grid item md={3} xs={12} position="relative">
          <FullAddressPicker
            entity={mask.entity}
            businessPartner={businessPartner?.data}
            project={project}
            contact={contact}
            businessPartnerType={SdObjType.KUNDE}
            expanded={editMode}
            onExpandChange={(expanded) => setEditMode(expanded)}
            onChange={(value) => {
              value.businessPartner &&
                setValue('mainAddress.businessPartner', value.businessPartner, {
                  shouldDirty: true,
                  shouldValidate: true,
                });
              value.contact !== undefined &&
                setValue('mainAddress.contact', value.contact, {
                  shouldDirty: true,
                  shouldValidate: true,
                });
              value.businessPartner?.language !== undefined &&
                setValue('language', value.businessPartner?.language, {
                  shouldDirty: true,
                  shouldValidate: true,
                });
            }}
            disableBusinessPartnerField={mask.isEditMode}
            disableAddressString
          />
        </Grid>

        <Grid item md={3} xs={12}>
          {
            <FullAddressPicker
              label={t('COMMON.DELIVERY_ADDRESS')}
              entity={mask.entity}
              businessPartner={deliveryAddress?.data}
              project={project}
              contact={deliveryAddressContact}
              businessPartnerType={SdObjType.KUNDE}
              compareBusinessPartnerId={businessPartner?.data?.id}
              compareContactId={contact?.id}
              combinedBusinessPartner
              expanded={editMode}
              onExpandChange={(expanded) => setEditMode(expanded)}
              onChange={(value) => {
                value.businessPartner &&
                  setValue(
                    'deliveryAddress.businessPartner',
                    value.businessPartner,
                    { shouldDirty: true, shouldValidate: true }
                  );
                value.contact !== undefined &&
                  setValue('deliveryAddress.contact', value.contact, {
                    shouldDirty: true,
                    shouldValidate: true,
                  });
              }}
              disableBusinessPartnerField={!businessPartner}
              disableAddressString
            />
          }
        </Grid>
        <Grid item md={3} xs={12}>
          {
            <FullAddressPicker
              label={t('COMMON.INVOICE_ADDRESS')}
              entity={mask.entity}
              businessPartner={endCustomer?.data}
              project={project}
              contact={endCustomerContact}
              businessPartnerType={SdObjType.KUNDE}
              compareBusinessPartnerId={businessPartner?.data?.id}
              compareContactId={contact?.id}
              combinedBusinessPartner
              expanded={editMode}
              onExpandChange={(expanded) => setEditMode(expanded)}
              onChange={(value) => {
                if (value.businessPartner) {
                  if (mask.isEditMode) {
                    enqueueSnackbar(t('WARNINGS.CHANGING_BILLING_ADDRESS'), {
                      variant: 'warning',
                      autoHideDuration: 6000,
                      action: (id) => {
                        return (
                          <>
                            <Button
                              sx={{
                                color: 'var(--ui01)',
                              }}
                              onClick={() => closeSnackbar(id)}
                            >
                              {t('COMMON.OK')}
                            </Button>

                            <IconButton
                              sx={{
                                color: 'var(--ui01)',
                              }}
                              onClick={() => closeSnackbar(id)}
                            >
                              <Close />
                            </IconButton>
                          </>
                        );
                      },
                    });
                  }
                  setValue(
                    'endCustomer.businessPartner',
                    value.businessPartner,
                    { shouldDirty: true, shouldValidate: true }
                  );
                }
                value.contact !== undefined &&
                  setValue('endCustomer.contact', value.contact, {
                    shouldDirty: true,
                    shouldValidate: true,
                  });
              }}
              disableBusinessPartnerField={!businessPartner}
              disableAddressString
            />
          }
        </Grid>
      </Grid>
    </Collapse>
  );
};
